// Hero — eyebrow chip, serif headline, sub-paragraph, two CTAs, then the
// hero canvas vignette below.

import { useCurrentUser } from "@/lib/auth";
import HeroVignette from "@/components/home/HeroVignette";
import { appHref } from "@/components/home/links";

export default function HomeHero() {
  const { data: user } = useCurrentUser();
  // Authed users go through /post-login so first-timers still hit /welcome
  // even when they arrive via the marketing landing.
  const startHref = user ? "/post-login" : "/login";

  return (
    <section className="relative mx-auto max-w-[1320px] px-7 pt-20 pb-12">
      <div
        className="mb-5 inline-flex items-center gap-2 rounded-full px-2.5 py-1 font-mono text-[11px] font-semibold uppercase tracking-[0.12em]"
        style={{
          background: "var(--accent-soft)",
          color: "var(--accent-deep)",
        }}
      >
        <span
          className="h-1.5 w-1.5 rounded-full"
          style={{ background: "var(--accent)" }}
        />
        Visual designer for AI harnesses
      </div>

      <h1
        className="serif mb-[22px] max-w-[1100px] text-[92px] font-normal leading-[0.98] tracking-[-0.025em] text-ink"
        style={{ textWrap: "pretty" }}
      >
        Design the system{" "}
        <em className="italic" style={{ color: "var(--accent-deep)" }}>
          before
        </em>
        <br />
        you write the prompts.
      </h1>

      <p
        className="mb-9 max-w-[640px] text-[19px] font-normal leading-[1.45] text-ink-2"
        style={{ textWrap: "pretty" }}
      >
        A canvas for thinking in multi-agent systems. Sketch the agents, tools,
        branches, and human gates &mdash; then export the blueprint to
        LangGraph, CrewAI, AutoGen, or raw Python and run it on the platform you
        already use. There&rsquo;s no agent runtime here. The point is the
        thinking.
      </p>

      <div className="mb-14 flex items-center gap-2.5">
        <a
          href={appHref(startHref)}
          className="inline-flex h-10 items-center gap-2 rounded-[9px] bg-ink px-[18px] text-[13.5px] font-medium text-canvas"
        >
          Start with Hello Harness
          <svg
            width="13"
            height="13"
            viewBox="0 0 16 16"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
            aria-hidden
          >
            <path d="M3 8h10M9 4l4 4-4 4" />
          </svg>
        </a>
        <a
          href="#concept"
          className="inline-flex h-10 items-center gap-1.5 rounded-[9px] border border-border bg-transparent px-4 text-[13.5px] font-medium text-ink-2"
        >
          What is a harness?
        </a>
      </div>

      <HeroVignette />

      <div className="mt-3.5 flex gap-4 font-mono text-[11px] tracking-[0.04em] text-muted">
        <span>// canvas-first · sketch to learn · export to ship</span>
      </div>
    </section>
  );
}
